// Route helper functions to replace RedwoodJS routes object
export const routes = {
  home: () => '/',
  admin: () => '/admin',
  log: (params) => {
    if (params?.page) {
      return `/log/${params.page}`
    }
    return '/log'
  },
  search: (params) => {
    if (params?.id) {
      return `/search/${params.id}`
    }
    return '/search'
  },
  school: (params) => {
    if (params?.id) {
      return `/school/${params.id}`
    }
    return '/'
  },
  stats: () => '/stats',
  settings: () => '/settings',
}

